<template lang="pug">

    .field(:class='{ required: isRequired }')
        label {{ label }}
        textarea(v-model='model' v-bind:readonly='isReadOnly' v-bind:disabled='isReadOnly')
        slot

</template>

<script>

    //noinspection ReservedWordAsName
    export default {
        computed: {
            model: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        props: {
            value: {
                required: true
            },
            label: {
                type: String,
                required: true
            },
            isReadOnly: {
                type: Boolean,
                default: false
            },
            isRequired: {
                type: Boolean,
                default: false
            }
        }
    }

</script>
